import text from './SearchNormalText.vue'
const SearchNormalText = {
  install: function (Vue) {
    Vue.component('SearchNormalText', text)
  }
}
export default SearchNormalText
